module.exports = __webpack_public_path__ + "img/logoseced.cf39654a.webp";